import React from 'react';
import { motion } from 'framer-motion';
import { ChevronLeftIcon } from 'lucide-react';
import { useCopy } from '../../contexts/LanguageContext';
interface ProgressHeaderProps {
  step: number;
  total: number;
  onBack: () => void;
}
export function ProgressHeader({
  step,
  total,
  onBack
}: ProgressHeaderProps) {
  const copy = useCopy();
  const percent = step / total * 100;
  const stepLabel = copy.quiz.stepOf(step, total);
  return <header className="mb-7 space-y-3" data-id="element-37" data-mp="kkxp5u7hvk5c">
      <div className="flex items-center gap-3" data-id="element-38" data-mp="on2lx1t8oww7">
        <button type="button" onClick={onBack} aria-label={copy.quiz.backLabel} className="grid h-10 w-10 shrink-0 place-items-center rounded-full border border-lavender-200 bg-white/90 text-ink-soft transition-colors active:scale-95 hover:text-violet-600" data-id="element-39" data-mp="olrij33phr5m">
          <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-40" data-mp="2vf3cdx0o2tf3" />
        </button>
        <p className="text-sm font-semibold text-ink-muted" data-id="element-41" data-mp="30deka27eituo">{stepLabel}</p>
      </div>
      <div className="h-2 w-full overflow-hidden rounded-full bg-lavender-100" role="progressbar" aria-valuemin={1} aria-valuemax={total} aria-valuenow={step} aria-label={stepLabel} data-id="element-42" data-mp="3hwgaii9zxfq5">
        <motion.div className="h-full rounded-full bg-violet-500" initial={false} animate={{
        width: `${percent}%`
      }} transition={{
        duration: 0.45,
        ease: [0.22, 1, 0.36, 1]
      }} data-id="element-43" data-mp="386mzbidrn2mf" />
      </div>
    </header>;
}